import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
import { View, StyleProp, ViewStyle } from 'react-native';

const WatchIcon = (props: {
    size?: number;
    primaryColor?: string;
    containerStyle?: StyleProp<ViewStyle>;
}) => {
    const size = props.size ?? 16;
    const width = size;
    const height = (size * (16/16));
    return (
        <View style={props.containerStyle}>
        <Svg
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill="none"
        >

            <Path
                d="M14.667 8A6.669 6.669 0 018 14.667 6.669 6.669 0 011.333 8 6.67 6.67 0 018 1.333 6.669 6.669 0 0114.667 8z"
                stroke={props.primaryColor ?? '#646464'}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <Path
                d="M10.473 10.12L8.407 8.887c-.36-.213-.654-.727-.654-1.147V5.007"
                stroke={props.primaryColor ?? '#646464'}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Svg>
        </View>
    );
};

export default WatchIcon;
